import { isFutureDate } from './CommonUtil';

const firstNameRegex = RegExp(/^^[a-zA-Z]+(')?[a-zA-Z]+?[ ]?(-)?[a-zA-Z]*(')?[a-zA-Z]*\s*$/);
const lastNameRegEx = RegExp(/^[a-zA-Z.]+(')?[a-zA-Z.]+?[ ]?(-)?[a-zA-Z.]*(')?[a-zA-Z.]*\s*$/);
const emailRegex = RegExp(/^[A-Za-z0-9!#$%&'.*+/=?^_`{|}~-]([A-Za-z0-9!#$%&'*.+/=?^_`{|}~-]([.])?){1,63}@(?:[a-zA-Z0-9_+-]{1,63}.){1,8}[a-zA-Z]{2,63}$/);
const dobRegex = RegExp(/^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/);
const ssnRegex = RegExp(/^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/);
const phoneRegex = RegExp(/^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$/);

function validateDateOfBirth(value) {
  let dateOfBirthErr = dobRegex.test(value) ? null : 'Please enter valid date of birth (MM/DD/YYYY).';
  if (!dateOfBirthErr && value.length === 10) {
    dateOfBirthErr = isFutureDate(value) ? 'Future date is not allowed.' : null;
  }
  return dateOfBirthErr;
}

const validateFields = (name, state) => {
  const value = state[name];
  const { formErrors } = { ...state };
  switch (name) {
    case 'first':
      formErrors.first = firstNameRegex.test(value) ? null : 'Please enter valid first name.';
      break;
    case 'last':
      formErrors.last = lastNameRegEx.test(value) ? null : 'Please enter valid last name.';
      break;
    case 'email':
      formErrors.email = emailRegex.test(value) ? null : 'Please enter valid email.';
      break;
    case 'phone':
      formErrors.phone = phoneRegex.test(value) ? null : true;
      break;
    case 'dateOfBirth':
      formErrors.dateOfBirth = validateDateOfBirth(value);
      break;
    case 'ssn':
      formErrors.ssn = ssnRegex.test(value) ? null : 'Please enter valid SSN.';
      break;
    case 'countryCallingCode':
      formErrors.countryCallingCode = value !== null ? null : true;
      break;
    default:
      throw new Error(`Tried to validate unknown field. Field name: ${name}`);
  }
  return formErrors;
};

export default validateFields;
